import { ApolloLink, Observable, Operation, FetchResult, NextLink } from '@apollo/client/core';
import { UtilitiesService } from '../../../services/utilities.service';
import { inject } from '@angular/core';

export class GraphQLLoggerLink extends ApolloLink {
	readonly #utilitiesService = inject(UtilitiesService);

	readonly #appLoader = 'graphqlLoader';

	constructor() {
		super();
	}

	public override request(operation: Operation, forward: NextLink): Observable<FetchResult> | null {
		return new Observable<FetchResult>((observer) => {
			const subscription = forward(operation).subscribe({
				next: (result) => {
					/*if (result.errors && result.errors.length > 0) {
						const errorMessage = result.errors.map((error) => error.message).join(', ');
						// this.#utilitiesService.showSnackbar('Error! ' + errorMessage);
						//console.log(result);
					}
					//this.#loaderService.dismissLoader(this.#appLoader);*/
					observer.next(result);
				},
				error: (networkError) => {
					/*const errorMessage = networkError?.message || 'Unknown network error';
					//this.#utilitiesService.showSnackbar('Error! ' + errorMessage);
					//console.log(networkError);

					//this.#loaderService.dismissLoader(this.#appLoader);*/
					observer.error(networkError);
				},

				complete: () => {
					observer.complete();
				}
			});

			return () => subscription.unsubscribe();
		});
	}

	private getOperationType(operation: Operation): string {
		const definition = operation.query.definitions[0];
		if (definition.kind === 'OperationDefinition') {
			return definition.operation.toUpperCase();
		}
		return 'UNKNOWN';
	}
}
